import React, { FC, useEffect } from 'react';
import styles from './PrintfulConnectionStep.scss';
import { EmptyState } from '@wix/design-system';
import { StatusAlert } from '@wix/wix-ui-icons-common';
import { HeaderLogo } from 'components/Header/HeaderLogo';
import { useTranslation } from '@wix/wix-i18n-config';
import { biEvents } from 'api/bi-events';
import { BI_STEP_NAME } from 'config/bi';
import { StepId } from 'config/steps';

export const PrintfulConnectionStep: FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    biEvents.errorState({
      screen: BI_STEP_NAME[StepId.PrintfulConnection],
      data: '',
    });
  }, []);

  return (
    <div className={styles.printfulConnectionStep}>
      <HeaderLogo />
      <EmptyState
        subtitle={t('printful-connection-step.subtitle')}
        title={t('printful-connection-step.title')}
        image={<StatusAlert />}
      />
    </div>
  );
};
